import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '../locales/en';
import th from '../locales/th';

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'en',
	messages: {
		en,
		th,
	},
});
